import { Injectable, DOCUMENT, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { OiamService as OiamServiceDPL } from '@now/dpl-webcomponents';
//TODO: Auf @oiambk umstellen, weg von @websso
import { SetConfigEventPayload } from '@websso/oiam-oauth-types';
import { LIB_CONFIG, LibConfig } from '../../lib.config';

export interface OiamConfig {
  clientId: string;
  redirecturi: string;
  logouturi: string;
  oiamOauthWcUrl: string;
  metadataUrl: string;
}

/**
 * Service zur Konfiguration des OIAM
 * Auf basis von ng-lib: https://bitbucket.webapp.sdst.sbaintern.de/projects/INFOSYSBUB/repos/
 * infosysbub-ng-lib-dpl3/browse/projects/infosysbub-ng-lib/src/lib/anwendungsbausteine/oiam/oiam.component.ts
 */
@Injectable({
  providedIn: 'root'
})
export class OiamService {
  private readonly router = inject(Router);
  private readonly document = inject<Document>(DOCUMENT);
  private readonly libConfig = inject<LibConfig>(LIB_CONFIG);

  private readonly oauthConfig: SetConfigEventPayload;
  private readonly oiamServiceDPL: OiamServiceDPL;

  public getOauthConfig(): string {
    //Die NOW Komponente braucht die config in serialisierter Form.
    return JSON.stringify(this.oauthConfig);
  }

  constructor() {
    const router = this.router;

    const oiamConfig = this.libConfig.oiam;
    this.oauthConfig = {
      clientid: oiamConfig.clientId,
      redirecturi: oiamConfig.redirecturi,
      logouturi: oiamConfig.logouturi,
      metadataUrl: oiamConfig.metadataUrl
    };
    this.oiamServiceDPL = new OiamServiceDPL(oiamConfig.oiamOauthWcUrl, this.oauthConfig);
    this.document.defaultView!.addEventListener('oiamCustomStateEvent', (e) =>
      // Redirect after a login event to the content of the customstate
      this.processCustomState(e as CustomEvent)
    );

    router.events.subscribe((urlChangeEvent) => {
      //Observe url changes and store the url in the customstate
      if (urlChangeEvent instanceof NavigationEnd) {
        this.oauthConfig.customstate = urlChangeEvent.url;
        // Setzt die oauthConfig inklusive u.a. customstate für redirect inklusive Query-Params.
        // Dabei nutzen wir Service aus NOW-webcomponents, welcher dann in Verantwortung ist,
        // dies ggf. zu Verzoegern bis alles korrekt geladen ist.
        // Manche parameter, wie die redirect url werden nur beim ersten mal gesetzt.
        // Andere Parameter, wie der customstate werden überschrieben.
        this.oiamServiceDPL.setConfiguration(this.oauthConfig);
      }
    });
  }

  /**
   * Redirect after a login event to the content of the customstate
   * @param e CustomEvent
   * @private
   */
  private processCustomState(e: CustomEvent) {
    const target = e.detail.customstate;
    this.router.navigateByUrl(target);
  }
}
